/** @jsx jsx */
import Checkbox from 'react-bootstrap/FormCheck';
import { jsx } from 'theme-ui';
import FormControl from './FormControl';
import FormGroup from './FormGroup';
import { ErrorMessage, useField } from 'formik';
import {
  FormControl as formControlStyles,
  FormGroup as formGroupStyles,
} from './Form.styles';

/**
 * A Checkbox input field controlled by formik.
 * @param {*} props The props forwarded to bootstrap's Checkbox.
 */
export default function FormCheckbox({
  label,
  name,
  variant = 'styles.input',
  required,
  placeholder,
  ...rest
}) {
  const [field, { error, touched }] = useField(name);
  label && (required && (label = `${label} *`));
  return (
    <FormGroup
      as="label"
      sx={{ display: 'block', variant, ...formGroupStyles }}
    >
      <Checkbox
        label={label}
        name={name}
        isValid={touched && !error}
        isInvalid={touched && !!error}
        required={required}
        sx={formControlStyles}
        {...field}
        {...rest}
      />
      {/* <ErrorMessage
          name={name}
          component={FormControl.Feedback} // In formik@2.0.1-rc.12, `as` is still `component` for <ErrorMessage>.
          type="invalid"
        /> */}
    </FormGroup>
  );
}
